/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OAuthAppTypeEnum } from './oAuthAppTypeEnum';
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface OAuthAppCredentialsSpec { 
    /**
     * Org Id in which the oauth app exist
     */
    org_id: string;
    service_type: ServiceTypeEnum;
    provider: CloudProvidersEnum;
    authorization_oauth_app_type: OAuthAppTypeEnum;
    /**
     * Region specific to cloud provider
     */
    target_region: string;
}
export namespace OAuthAppCredentialsSpec {
}


